import { ReactComponent as FemaleIcon } from '../../icons/female.svg';
import { ReactComponent as MaleIcon } from '../../icons/male.svg';

export const icons = {
    female: FemaleIcon,
    male: MaleIcon,
};
